import { api } from '@smena/ui';

export type KbFactStatus = 'draft' | 'approved' | 'rejected';
export type KbFactSource = 'parser' | 'import' | 'dialog' | 'manual' | 'onboarding';

export interface KbFact {
  id: string;
  propertyId: string | null;
  key: string;
  value: string;
  status: KbFactStatus;
  source: KbFactSource;
  sourceRef: string | null;
  updatedBy: string | null;
  updatedByName: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function fetchKbFacts(input: {
  propertyId?: string | 'null';
  status?: KbFactStatus;
  q?: string;
}): Promise<{ items: KbFact[]; counts: { draft: number; approved: number; rejected: number } }> {
  const p = new URLSearchParams();
  if (input.propertyId) p.set('propertyId', input.propertyId);
  if (input.status) p.set('status', input.status);
  if (input.q) p.set('q', input.q);
  return api(`/api/staff/kb/facts?${p.toString()}`);
}

export async function createKbFact(data: {
  propertyId?: string | null;
  key: string;
  value: string;
}): Promise<KbFact> {
  return api('/api/staff/kb/facts', { method: 'POST', json: data });
}

export async function patchKbFact(
  id: string,
  data: { key?: string; value?: string; status?: KbFactStatus },
): Promise<KbFact> {
  return api(`/api/staff/kb/facts/${id}`, { method: 'PATCH', json: data });
}

export async function deleteKbFact(id: string): Promise<void> {
  await api(`/api/staff/kb/facts/${id}`, { method: 'DELETE' });
}

export async function approveKbFact(id: string): Promise<KbFact> {
  return api(`/api/staff/kb/facts/${id}/approve`, { method: 'POST', json: {} });
}

export async function rejectKbFact(id: string): Promise<KbFact> {
  return api(`/api/staff/kb/facts/${id}/reject`, { method: 'POST', json: {} });
}

export interface RebuildKbFactsInput {
  propertyId?: string;
  sourceType?: 'listing' | 'avito_chat' | 'all';
  limit?: number;
}

export interface RebuildKbFactsResult {
  scanned: number;
  drafted: number;
  updated: number;
  deduped: number;
}

/** LLM-майнинг фактов из kb_documents. Может вернуть 403 если KB_FACT_MINING=0 на сервере. */
export async function rebuildKbFacts(input: RebuildKbFactsInput = {}): Promise<RebuildKbFactsResult> {
  return api('/api/staff/kb/facts/rebuild', { method: 'POST', json: input });
}
